import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function LeadershipSection() {
  return <Section background="ivory" className="bg-purple-100" data-id="element-211" data-mp="318h7a5kkqo3e">
      <div className="max-w-5xl mx-auto" data-id="element-212" data-mp="3f0f7ts07zbny">
        <FadeIn data-id="element-213" data-mp="3f05h227cp0h7">
          <div className="text-sm uppercase tracking-widest text-charcoal/50 font-semibold mb-12 text-center" data-id="element-214" data-mp="3ezvt0k5v93e5">
            Leadership
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center" data-id="element-215" data-mp="2nais4xyfinmu">
          <div className="md:col-span-5 flex justify-center md:justify-end" data-id="element-216" data-mp="2iaxx2ymdqzfe">
            <FadeIn delay={200} data-id="element-217" data-mp="2wa5wnsmgg9k4">
              <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-4 border-white shadow-2xl relative" data-id="element-218" data-mp="2wb8l7twb1zwv">
                <img src="https://cdn.magicpatterns.com/uploads/iaRG4kZcCwyQ5NpfatJgYW/Mukisa.png" alt="Mukisa Kakembo" className="w-full h-full object-cover hover:scale-105 transition-all duration-700" data-id="element-219" data-mp="2r9rl40lnahhc" />
              </div>
            </FadeIn>
          </div>

          <div className="md:col-span-7 text-center md:text-left" data-id="element-220" data-mp="2lxre2pf8bvqb">
            <FadeIn delay={400} data-id="element-221" data-mp="2lvy87ccfxfjd">
              <h3 className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-222" data-mp="2qwuj49v7m1ya">
                Mukisa Kakembo
              </h3>
              <div className="text-purple-700 font-medium tracking-wide mb-6 uppercase text-sm" data-id="element-223" data-mp="2vuw450c74bce">
                Founder & CEO
              </div>
              <p className="text-lg text-charcoal/70 leading-relaxed max-w-lg mx-auto md:mx-0" data-id="element-224" data-mp="1y63yv4rby93v">
                Mukisa Kakembo leads Fem Entity with a vision to redefine how
                women experience wellness globally — merging ethical frameworks,
                technology, and community to build a new category of care.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </Section>;
}